import React from 'react';
import { Router, Route, IndexRoute, browserHistory } from 'react-router';
import Root from './components/Root';
import Listing from './components/Listing';
import SubPage from './components/SubPage';
import ListingMap from './components/ListingMap';
import PropertyMap from './components/PropertyMap';
import BuyerList from './components/BuyerList';
import SellerList from './components/SellerList';
import AgentList from './components/AgentList';
import FirmList from './components/FirmList';
import TenantList from './components/TenantList';
import LenderList from './components/LenderList';
import Stats from './components/Stats';
import GeoCoder from './components/GeoCoder';
import Pipeline from './components/Pipeline';
import Inventory from './components/Inventory';
import AgentPipeline from './components/AgentPipeline';
import Error404 from './components/Error404';
import Super from './components/Super';
import EscrowTracking from "./components/EscrowTracking/EscrowTracking";
import SuperAgent from './components/SuperAgent';
import AgentPipelineDetails from './components/AgentPipelineDetails/AgentPipelineDetails';
import BuyerStateBreakdown from './components/BuyerStateBreakdown';
import ListingFilter from './components/ListingFilter';
import SellerListFilter from "./components/SellerListFilter";
import AgentListFilter from "./components/AgentListFilter";
import FirmListFilter from "./components/FirmListFilter";
import TenantListFilter from "./components/TenantListFilter";
import TransactionBreakdown from "./components/TransactionBreakdown";
import UploadFile from "./components/UploadFile/UploadFile";
import MarketTransactionBreakdown from "./components/MarketTransactionBreakdown";
import PropertyStatistics from "./components/PropertyStatistics";
import BuyerListFilter from "./components/BuyerListFilter";
import Buckets from "./components/Buckets/Buckets";
import BucketsDetails from "./components/BucketsDetails/BucketsDetails";
import StriveFees from "./components/StriveFees";
import CRUDProperty from './components/CRUDProperty';
import CRUDTenant from './components/CRUDTenant';
import CRUDLender from './components/CRUDLender';
import CRUDFirm from './components/CRUDFirms';
import CRUDAgent from './components/CRUDAgent';
import CRUDBuyer from './components/CRUDBuyer';
import CRUDSeller from './components/CRUDSeller';
import HscPipeline from "./components/HscPipeline/HscPipeline";
import HscTracking from "./components/HscTracking/HscTracking";
import LenderListFilter from "./components/LenderListFilter";
import HscPipelineFees from "./components/HscPipelineFees";
import Training from "./components/Training";
import TrainingSwitch from "./components/TrainingSwitch/TrainingSwitch";
import ChapterContentSwitch from "./components/ChapterContentSwitch/ChapterContentSwitch";

export default (
	<Router history={browserHistory}>
		<Route path={arc.path.base} component={Root}>
			<IndexRoute component={Stats}/>
			<Route component={ListingFilter}>
				<Route path='list' component={Listing}/>
				<Route path='map' component={ListingMap}/>
				<Route path='map/:id' component={PropertyMap}/>
                <Route path='buyer-state-breakdown' component={BuyerStateBreakdown}/>
                <Route path='transaction-breakdown' component={TransactionBreakdown}/>
                <Route path='market-transaction-breakdown' component={MarketTransactionBreakdown}/>
			</Route>
            <Route component={SuperAgent}>
				<Route path='property'>
					<IndexRoute component={CRUDProperty}/>
					<Route path=':id' component={(props) => <CRUDProperty {...props} edit/>}/>
				</Route>
                <Route component={BuyerListFilter}>
                    <Route path='buyers' component={BuyerList}/>
                </Route>
                <Route path='agent-pipeline' component={AgentPipeline}/>
                <Route path='agent-pipeline/:id' component={(props) => <AgentPipelineDetails {...props} isAgentPipeline/>}/>
                <Route path='buckets' component={Buckets}/>
                <Route path='buckets/:id' component={BucketsDetails}/>
				<Route path='property-statistics/:id' component={PropertyStatistics}/>
				<Route path='pipeline' component={Pipeline}/>
                <Route path='inventory' component={Inventory}/>
                <Route path='escrow-tracking' component={EscrowTracking}>
                    <Route path=':id'/>
                </Route>
				<Route path='training' component={Training}/>
				<Route path='training/:slug' component={TrainingSwitch}/>
				<Route path='training/:slug/:slug2' component={ChapterContentSwitch}>
					<Route path=':slug3'>
						<Route path=':slug4'>
							<Route path=':slug5'/>
						</Route>
					</Route>
				</Route>
			</Route>
			<Route component={Super}>
				<Route component={SellerListFilter}>
                    <Route path='sellers' component={SellerList}/>
				</Route>
                <Route component={AgentListFilter}>
                    <Route path='agents' component={AgentList}/>
                </Route>
                <Route component={FirmListFilter}>
					<Route path='firms' component={FirmList}/>
				</Route>
				<Route component={TenantListFilter}>
                    <Route path='tenants' component={TenantList}/>
                </Route>
				<Route component={LenderListFilter}>
					<Route path='lenders' component={LenderList}/>
				</Route>
                <Route path='strive-fees' component={StriveFees}/>
                <Route path='hsc-pipeline' component={HscPipeline}/>
                <Route path='hsc-pipeline/:id' component={HscPipelineFees}/>
				<Route path='hsc-tracking' component={HscTracking}>
                    <Route path=':id'/>
                </Route>
				<Route component={SubPage}>
					<Route path='geocoder'>
						<IndexRoute component={GeoCoder}/>
					</Route>
					<Route path='upload-file' component={UploadFile}/>
				</Route>
				<Route path='firm'>
					<IndexRoute component={CRUDFirm}/>
					<Route path=':id' component={(props) => <CRUDFirm {...props} edit />} />
				</Route>
				<Route path='tenant'>
					<IndexRoute component={CRUDTenant}/>
					<Route path=':id' component={(props) => <CRUDTenant {...props} edit />} />
				</Route>
				<Route path='lender'>
					<IndexRoute component={CRUDLender}/>
					<Route path=':id' component={(props) => <CRUDLender {...props} edit />} />
				</Route>
				<Route path='agent'>
					<IndexRoute component={CRUDAgent}/>
					<Route path=':id' component={(props) => <CRUDAgent {...props} edit />} />
				</Route>
				<Route path='buyer'>
					<IndexRoute component={CRUDBuyer}/>
					<Route path=':id' component={(props) => <CRUDBuyer {...props} edit />} />
				</Route>
				<Route path='seller'>
					<IndexRoute component={CRUDSeller}/>
					<Route path=':id' component={(props) => <CRUDSeller {...props} edit />} />
				</Route>
			</Route>
			<Route path='*' component={Error404}/>
		</Route>
	</Router>
);